module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('category.label')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.from.category),
      expression: "item.from.category"
    }],
    staticClass: "form-select",
    attrs: {
      "columns": 3,
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.item.from.category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.from, "category", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('departments.label'),
      "columns": 3
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.to.department),
      expression: "item.to.department"
    }],
    staticClass: "form-select",
    attrs: {
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.item.to.department)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.to, "department", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('productTypes.label'),
      "columns": 3
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.to.productType),
      expression: "item.to.productType"
    }],
    staticClass: "form-select",
    attrs: {
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.item.to.productType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.to, "productType", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-col-1@md vertical-center"
  }, [_c('i', {
    staticClass: "i-arrow icon-arrow-right center"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-058d33c7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/presets/ecommerce/moovin/marketplace/netshoes/CategorizationItem.vue
// module id = 2876
// module chunks = 0